import React from 'react';

export const pageMeta = {
  "name": "Object Methods",
  "link": "/javascript/objects/methods"
};

export default function JavascriptObjectsMethods() {
  return (
    <div className="p-6 max-w-3xl mx-auto">
      <h2 className="text-2xl font-semibold mb-2">Object Methods</h2>
      <p>Route: /javascript/objects/methods</p>
      <h3 className="mt-4 font-medium">sub_content</h3>
      <pre>{JSON.stringify(pageMeta, null, 2)}</pre>
    </div>
  );
}
